module.exports = __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/spotify-14e2c2184297bbf9d94572a9f801f98e.svg";